import { io, Socket } from "socket.io-client";
import type { SSHError } from "./types/ssh-errors";

export interface SSHReadyData {
  /** True when an existing shell was resumed after a transport drop. */
  resumed: boolean;
}

interface ServerToClientEvents {
  "ssh:data": (data: string) => void;
  "ssh:error": (error: SSHError) => void;
  "ssh:close": () => void;
  "ssh:ready": (data: SSHReadyData) => void;
}

interface ClientToServerEvents {
  "ssh:connect": (data: {
    sessionId: string;
    term?: string;
    cols?: number;
    rows?: number;
  }) => void;
  "ssh:data": (data: string) => void;
  "ssh:resize": (data: { cols: number; rows: number }) => void;
  "ssh:disconnect": () => void;
}

const url = new URL(
  import.meta.env.VITE_APP_API_BASE_URI,
  window.location.origin,
);

export const socket: Socket<ServerToClientEvents, ClientToServerEvents> = io(
  url.origin,
  {
    path: `${url.pathname}socket.io`,
    autoConnect: false,
    transports: ["websocket"],
    // The edge in front of the extension severs long-lived websockets
    // regularly, so reconnect quickly and keep trying.
    reconnection: true,
    reconnectionAttempts: Infinity,
    reconnectionDelay: 500,
    reconnectionDelayMax: 3000,
  },
);
